import { deflateData, runSandbox, setupHandle } from './sandbox-utils';
import { initSandboxNav } from './create-nav-buttons';
import { setupSandboxInputHandlers } from './input-handlers';
import { percentRemaining } from './element-selectors';
import { setColourMode } from '../colour-mode';

initSandboxNav();

document.addEventListener('DOMContentLoaded', () => {
  setColourMode('dark');
  setupSandboxInputHandlers();
  runSandbox();
  setupHandle();

  const { remainingPercentage } = deflateData();
  percentRemaining.innerHTML = `${remainingPercentage}%`;
});
